import { render, staticRenderFns } from "./ticketDetails.vue?vue&type=template&id=4913174e"
import script from "./ticketDetails.vue?vue&type=script&lang=js"
export * from "./ticketDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports